import { inject } from '@angular/core';
import type { HttpInterceptorFn } from '@angular/common/http';

import { AuthService } from '../auth/auth.service';
import { environment } from '../../../environments/environment';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const token = auth.token();
  // /public/** se autentica por X-API-Key (ver public-api.service.ts), nunca por JWT — mandar
  // ambos hace que el backend autentique como el usuario admin (ROLE_ADMIN) en vez de ROLE_PUBLIC,
  // ya que ApiKeyAuthFilter no pisa una autenticación previa, y la ruta pública rechaza con 403
  // por falta de ROLE_PUBLIC.
  const isAdminApiRequest = req.url.startsWith(environment.apiUrl) && !req.url.includes('/public/');

  if (!token || !isAdminApiRequest) {
    return next(req);
  }

  return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
